// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_main__ea-1r {
    display: flex;
    justify-content: center;
}

.Button_button__r1E9E {
    background-color: #015933;
    font-weight: bold;
    width: fit-content;
    padding: 10px 20px;
    border-radius: 10px;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/Components/Button.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".main {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.button {\r\n    background-color: #015933;\r\n    font-weight: bold;\r\n    width: fit-content;\r\n    padding: 10px 20px;\r\n    border-radius: 10px;\r\n    color: white;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Button_main__ea-1r`,
	"button": `Button_button__r1E9E`
};
export default ___CSS_LOADER_EXPORT___;
